import {Component, Inject, OnInit} from '@angular/core';
import {AnalyticsService} from '../components/analytics-service/analytics.service';
import {FirebaseService} from '../components/firebase-service/firebase-service.service';

import { PageScrollService } from 'ngx-page-scroll-core';
import {DOCUMENT} from '@angular/common';

@Component({
  selector: 'app-research',
  templateUrl: './research.component.html',
  styleUrls: ['./research.component.scss']
})
export class ResearchComponent implements OnInit {

  projects: {
    data: any[],
    analytics: any[]
  };
  analytics_subcategory: any[];
  tags: any[];
  openProject: string;
  dataPath = 'portfolio/';


  constructor(
    private analyticsService: AnalyticsService,
    private firebaseService: FirebaseService,
    private pageScrollService: PageScrollService,
    @Inject(DOCUMENT) private document: any) {
    this.projects = {
      data: [],
      analytics: []
    };
    this.analytics_subcategory = [];
    this.analyticsService.emitEvent(
      'Page visit',
      'Research'
    );
  }
  ngOnInit() {
    this.analytics_subcategory = [
      'pre-processing',
      'algorithms',
      'integration'
    ];
    this.openProject = '';
    this.tags = [
      'dark',
      'dark',
      'primary',
      'primary',
      'primary',
      'secondary',
      'secondary',
      'danger',
      'danger',
      'warning',
      'warning',
      'warning',
      'warning',
      'info',
      'info',
      'info',
      'info',
      'success',
      'success',
      'success',
      'success',
    ];
    this.projects = {
      data: [],
      analytics: []
    };

    this.firebaseService.getCollection(this.dataPath, 'order_index').subscribe(res => {
      this.projects.data = [];
      this.projects.analytics = [];
      // @ts-ignore
      for (const project of res) {
        const projCp = project;
        projCp.tags = [];
        if (!!project.tag) {
          for (const tag of project.tag.split(',')) {
            const mytag = {
              name: tag,
              color: this.getRandomTag()
            };
            projCp.tags.push(mytag);
          }
        }

        if (!!projCp.category) {
          if (projCp.category.includes('data')) {
            this.projects.data.push(projCp);
          }
          if (projCp.category.includes('analytics')) {
            this.projects.analytics.push(projCp);
          }
        }
      }
    });
  }

  getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }
  getRandomTag() {
    return 'btn-outline-' + this.tags[this.getRandomInt(this.tags.length)];
  }

  toggleProject(project) {
    if (project === this.openProject) {
      this.openProject = '';
    } else {
      this.openProject = project;
     setTimeout(() => {
       this.pageScrollService.scroll({
         document: this.document,
         scrollTarget: '#' + this.getId(this.openProject),
         scrollOffset: 120
       });
     }, 50);
    }
  }

  getId(title) {
    return title.replace(new RegExp(' ', 'g'), '_');
  }


}
